export const visualSweepsConfig = {
    gameSlug: 'visual-sweeps',
    category: 'feu_vivacite',
    variable: 'duration_ms',
    startValue: 200,
    minValue: 8,
    maxValue: 600,
    stepSizesByPhase: [40, 20, 10, 5],
    reversalsToConverge: 6,
    reversalsForThreshold: 4,
    maxTrials: 70,
    direction: 'down-easier',
};
export const doubleDecisionConfig = {
    gameSlug: 'double-decision',
    category: 'air_attention',
    variable: 'duration_ms',
    startValue: 250,
    minValue: 16,
    maxValue: 500,
    stepSizesByPhase: [50, 25, 12, 6],
    reversalsToConverge: 6,
    reversalsForThreshold: 4,
    maxTrials: 60,
    direction: 'down-easier',
};
export const memoryGridConfig = {
    gameSlug: 'memory-grid',
    category: 'eau_memoire',
    variable: 'n_items',
    startValue: 3,
    minValue: 2,
    maxValue: 9,
    stepSizesByPhase: [1, 1, 1],
    reversalsToConverge: 6,
    reversalsForThreshold: 4,
    maxTrials: 50,
    direction: 'down-easier',
};
export const mentalMapConfig = {
    gameSlug: 'mental-map',
    category: 'terre_navigation',
    variable: 'grid_size',
    startValue: 4,
    minValue: 3,
    maxValue: 8,
    stepSizesByPhase: [1, 1],
    reversalsToConverge: 5,
    reversalsForThreshold: 3,
    maxTrials: 30,
    direction: 'up-easier',
};
export const mindBenderConfig = {
    gameSlug: 'mind-bender',
    category: 'foudre_logique',
    variable: 'item_rank',
    startValue: 50,
    minValue: 1,
    maxValue: 200,
    stepSizesByPhase: [20, 10, 5, 2],
    reversalsToConverge: 5,
    reversalsForThreshold: 3,
    maxTrials: 30,
    direction: 'down-easier',
};
export const faceFactsConfig = {
    gameSlug: 'face-facts',
    category: 'lumiere_emotions',
    variable: 'n_items',
    startValue: 4,
    minValue: 2,
    maxValue: 12,
    stepSizesByPhase: [2, 1, 1],
    reversalsToConverge: 5,
    reversalsForThreshold: 3,
    maxTrials: 40,
    direction: 'down-easier',
};
export const defaultConfigs = {
    'visual-sweeps': visualSweepsConfig,
    'double-decision': doubleDecisionConfig,
    'memory-grid': memoryGridConfig,
    'mental-map': mentalMapConfig,
    'mind-bender': mindBenderConfig,
    'face-facts': faceFactsConfig,
};
//# sourceMappingURL=configs.js.map